import React, {useCallback} from "react";
import {Link} from "react-router-dom";


export default ({disabled, active, pages}) => {
    const linkClick = useCallback((e) => {
        if (disabled) {
            e.preventDefault();
        }

    }, [disabled]);

    return (
        <>
            {
                pages //.filter(e=>e.component !== active)
                    .map((e,i) => <div key={i} className={'link'}>
                            <Link onClick={linkClick} to={e.path}>{e.text}</Link>
                        </div>
                    )}
        </>
    );
}
